import styled from 'styled-components'
import { screenSizes } from '@shipt/design-system-themes'
import { BaseModalWrapper, ModalButtonGroup } from '@/features/shared/elements/Modals/styles'
import {
  createModal,
  createHeader,
  createContent,
  createFooter,
} from '@/features/shared/elements/Modals/factories'
import { Headline } from '@shipt/design-system-typography'

const ModalWrapper = styled(BaseModalWrapper)`
  height: 100%;
  width: 100%;
  max-width: 768px;

  @media ${screenSizes.tablet} {
    height: auto;
    width: 70%;
    border-radius: 1rem;
    max-height: 90%;
  }

  @media ${screenSizes.smDesktop} {
    width: 50%;
  }
`

export const ModalTitle = styled(Headline)`
  padding-bottom: 4px;
`

const LargeModalButtonGroup = styled(ModalButtonGroup)`
  @media ${screenSizes.tablet} {
    div {
      flex-direction: row-reverse;

      button {
        width: unset;
        max-width: unset;
      }

      button + button {
        margin-top: 0;
        margin-right: 16px;
      }

      .modal-secondary-text-button {
        margin-top: 0;
      }
    }
  }
`

/**
 *
 * Mocks: https://www.figma.com/file/SWPhdIsgPAHmghzvdC2Yzs/Member-DLS-2021?node-id=310%3A458
 */
const Modal = createModal({ modalFrame: ModalWrapper })
export const Header = createHeader()
export const Content = createContent({ size: 'large', title: ModalTitle })
export const Footer = createFooter({ buttonGroup: LargeModalButtonGroup })

export default Modal
